'use strict';

const _ = require('underscore');
const i18n = require('i18next');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const Router = require('balus/app/router/index');
const EmptyItem = require('common/ui/view/empty-item');
const GroupMemberIconView = require('common/ui/view/group/member-icon');
const GroupMemberNameView = require('common/ui/view/group/member-name');
const ActionStateService = require('process/app/service/action/state');
const AssigneeItemTemplate = require('process/ui/template/action/assignee-item.hbs');
const ActionStateView = require('process/ui/view/action/state');
const ActionDateView = require('process/ui/view/action/date');
const ContentActionWorkRepository = require('balus/infra/repository/actionwork/content');
const DiagramActionWorkRepository = require('balus/infra/repository/actionwork/diagram');
const ContentWorkListView = require('balus/ui/view/body/process/content/content-work');
const DiagramWorkListView = require('balus/ui/view/body/process/content/diagram-work');
const Template = require('balus/ui/template/body/process/content/index.hbs');
const ContainerRepository = require('data/domain/repository/container/index');
const Marked = require('balus/util/marked');

const AssigneeItemView = Mn.View.extend({
    tagName: 'span',
    template: AssigneeItemTemplate,
    regions: {
        icon: '.assignee-icon',
        title: '.assignee-name',
    },
    onRender: function() {
        this.showChildView('icon', new GroupMemberIconView({
            model: this.model
        }));
        this.showChildView('title', new GroupMemberNameView({
            model: this.model
        }));
    }
});

const AssigneeListView = Mn.CollectionView.extend({
    childView: AssigneeItemView,
    emptyView: EmptyItem
});

module.exports = Mn.View.extend({
    template: Template,
    className: 'process-content-detail',
    modelEvents: {
        'change': 'render'
    },
    regions: {
        actionState: '.action-state',
        actionDate: '.action-date',
        assigneeList: '.assignee-list',
        contentList: '.data-content-list',
        diagramList: '.diagram-list'
    },
    childViewTriggers: {
        'content:add:comment': 'content:add:comment',
        'content:add:task': 'content:add:task',
        'model:add:comment': 'model:add:comment',
        'model:add:task': 'model:add:task'
    },
    childViewEvents: {
        'proceed:state': 'proceed'
    },

    templateContext: function() {
        const desc = this.model.getDescription();
        return {
            title: this.model.getName(),
            state: this.model.getCurrentState().toJSON(),
            description: Marked()(desc ? desc : ''),
            nextStates: _.map(this.model.getProceedableStates(), s => s.toJSON()),
        }
    },

    onRender: function() {
        const project = this.model.getProject();

        this.showChildView('assigneeList', new AssigneeListView({
            collection: new Backbone.Collection(this.getSortedAssignees())
        }));

        this.showChildView('actionState', new ActionStateView({
            model: this.model,
            context: this.getOption('context')
        }));
        this.showChildView('actionDate', new ActionDateView({
            model: this.model
        }));

        ContainerRepository.find(project)
            .fetchRootOnce()
            .then(rootContainer => {
                if(!rootContainer.id) {
                    return;
                }
                ContentActionWorkRepository.find(this.model.getProject())
                    .fetchActionWorksByActionOnce(this.model, 5)
                    .then(actionWorks => {
                        this.showChildView('contentList', new ContentWorkListView({
                            model: this.model,
                            collection: actionWorks,
                            context: this.getOption('context')
                        }));
                    });
            });

        DiagramActionWorkRepository.find(this.model.getProject())
            .fetchActionWorksByActionOnce(this.model, 5)
            .then(actionWorks => {
                this.showChildView('diagramList', new DiagramWorkListView({
                    model: this.model,
                    collection: actionWorks,
                    context: this.getOption('context')
                }));
            });
    },

    // 担当者に自分が入っている時は先頭にする
    getSortedAssignees: function() {
        const user = this.getOption('context').getUser();
        const group = this.getOption('context').getGroup();
        let assignees = _.map(this.model.getAssignees(), a => group.getMembers({withSuspended: true}).getMemberByUser(a));

        if(assignees.length > 0) {
            const index = _.findIndex(assignees, assignee => {
                return assignee.id == user.id;
            });
            if(index !== -1) {
                const assignedUser = assignees.splice(index, 1);
                assignees.unshift(assignedUser[0]);
            }
        }

        return assignees;
    },

    onChildviewActionClick: function(action) {
        Router.navigate(`/projects/${this.model.getProject().id}/processes/${action.id}`, {trigger: true});
    },

    proceed: function(child) {
        const nextState = child.model;
        (new ActionStateService(this.model, nextState)).proceed();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/process/content/index.js